import { TmBaseError } from '@/core/error/tmBaseError'

type TmTableElementManagerErrorData = {
  tableId: string
}

export class TmTableElementManagerError extends TmBaseError<TmTableElementManagerErrorData> {
  public name = 'TmTableElementManagerError'
}
